import {
	Avatar,
	Box,
	Chip,
	Link,
	Paper,
	Stack,
	Typography,
} from "@mui/material";
import { ProductTimeline } from "./ProductTimeline";

export const ProductList = ({ products }) => {
	return (
		<Box
			// component={Paper}
			sx={{ width: "100%" }}
		>
			{products.map((item, index) => (
				<Stack
					key={`product-${index}`}
					component={Paper}
					sx={{
						width: "100%",
						alignItems: "flex-start", // align text and image nicely
						mb: products.length - 1 === index ? 0 : 1,
						backgroundColor: "transparent",
						p: 2,
					}}
				>
					<Stack
						key={`product-${index}`}
						direction={{ xs: "column", sm: "row" }}
						// component={Paper}
						sx={{
							width: "100%",
							alignItems: "flex-start", // align text and image nicely
							mb: products.length - 1 === index ? 0 : 1,
							backgroundColor: "transparent",
							// p: 2,
							gap: 2, // spacing between image and content
						}}
					>
						{/* Image Box */}
						<Box
							sx={{
								position: "relative",
								width: 60,
								flexShrink: 0,
								aspectRatio: "3 / 4",
								borderRadius: 2,
								overflow: "hidden",
							}}
						>
							<Avatar
								variant="square"
								src={item.image}
								sx={{
									position: "absolute",
									top: 0,
									left: 0,
									width: "100%",
									height: "100%",
									objectFit: "cover",
								}}
							/>
						</Box>

						{/* Info Box */}
						<Box sx={{ flexGrow: 1 }}>
							{[
								{
									label: "Name",
									value: (
										<Link
											target="_blank"
											href={
												item.affiliated_url !== null &&
												item.affiliated_url !==
													undefined &&
												item.affiliated_url !== ""
													? item.affiliated_url
													: item.url
											}
										>
											{item.title}
										</Link>
									),
								},
								{
									label: "QTY",
									value: (
										<Typography
											component="p"
											variant="body2"
										>
											{item.quantity}
										</Typography>
									),
								},
								{
									label: "Size",
									value: (
										<Typography
											component="p"
											variant="body2"
										>
											{item.attributes?.[0]?.value || "—"}
										</Typography>
									),
								},
								{
									label: "Status",
									value: (
										<Chip
											size="small"
											variant="outlined"
											color="primary"
											label={item.status}
										/>
									),
								},
							].map((field) => (
								<Box
									key={field.label}
									display="flex"
									justifyContent={{
										xs: "space-between",
										md: "inherit",
									}}
								>
									<Typography
										variant="p"
										sx={{
											minWidth: { xs: "auto", sm: 50 },
											mr: 1,
										}}
									>
										{field.label}:
									</Typography>
									{field.value}
								</Box>
							))}
						</Box>
					</Stack>
					<ProductTimeline line={item} />
				</Stack>
			))}
		</Box>
	);
};
